<div class="detail">
  <h1>Validátor VFZE</h1>
    <fieldset style="width: 700px;min-width: 400px;margin: 0 auto;">
      <div class="fieldset no-padding">
        <div class="legend">Soubor VFZE</div>
        <fileupload (change)="onFilesChange($event)" [message]="filesMsg" [files]="files"></fileupload>
      </div>

      <div *ngIf="vfzeMetadata" class="mt-20 mb-20">
        <div class="bordered fieldset flexbox-container">
          <div class="legend">Informace o VFZE</div>
          <div class="column-100">
            <label>Verze VFZE</label> <div class="info">{{ vfzeMetadata.verzeFormat }}</div>
            <label>Datum platnosti KN dat</label> <div class="info">{{ vfzeMetadata.platnostDatKn | date }}</div>
            <label>Datum vytvoření VFZE</label> <div class="info">{{ vfzeMetadata.platnostExportu | date }}</div>
            <label>Software</label> <div class="info">{{ vfzeMetadata.software }}</div>
            <label>Autor</label> <div class="info">{{ vfzeMetadata.autor }}</div>
            <label>Název akce</label> <div class="info">{{ vfzeMetadata.nazev }}</div>
          </div>
        </div>
      </div>

      <div class="centered-text">
        <gmt-button [clickAction]="onUpload" [gmtDisabled]="!isFileValidToUpload">Spustit validaci souboru</gmt-button>
        <a uiSref="vfze.map" target="_blank" (click)="!isFileValidToUpload ? $event.preventDefault() : null" [ngClass]="{ disabled: !isFileValidToUpload }" class="button ml-10">Náhled</a>
      </div>

      <div *ngIf="partialMessageLog?.length > 0" class="mt-20">
        <div *ngFor="let log of partialMessageLog; index as i" class="mb-5">
          <span class="fa fa-check-circle" style="color: green;" *ngIf="i < partialMessageLog.length-1"></span>
          <span class="content-loading small-spinner right" style="display:inline;" *ngIf="i == partialMessageLog.length-1">
            <span class="loader"><span class="loading-spinner"></span></span>
          </span>
          {{ log }}
        </div>
      </div>

      <div *ngIf="validationResponse" class="mt-20">
        <div *ngIf="getValidationResult() as result" class="clearfix">
          <div style="float: left; margin: 10px 10px 10px;">
            <span class="fa fa-check-circle fa-3x" style="color: green;" *ngIf="result === 'success'"></span>
            <span class="fa fa-check-circle fa-3x" style="color: green;" *ngIf="result === 'warning'"></span>
            <span class="fa fa-times-circle fa-3x" style="color: red;" *ngIf="result === 'error' || result === 'fatal'"></span>
          </div>

          <p class="{{ result === 'fatal' ? 'error' : (result === 'warning' ? 'success' : result) }}-message">
            <span *ngIf="result === 'success'">Validace proběhla úspěšně.</span>
            <span *ngIf="result === 'warning'">Validace proběhla úspěšně. Protokol obsahuje varování na možné nesoulady. Doporučena kontrola.</span>
            <span *ngIf="result === 'error'">Validace skončila neúspěšně, s chybami.</span>
            <span *ngIf="result === 'fatal'">Validace skončila neúspěšně. Nesoulad s XSD šablonou.</span>
          </p>

          <p *ngIf="validationResponse.validationMessage">
            {{ validationResponse.validationMessage }}
          </p>
        </div>
        <div class="mt-20 centered-text">
          <gmt-button [clickAction]="onSaveValidationResponse">Stáhnout protokol validace</gmt-button>
          <a *ngIf="containResponseErrors()"
             (click)="xmlErrorsDisplayed = !xmlErrorsDisplayed"
             class="button ml-10"
          >{{ xmlErrorsDisplayed ? 'Skrýt chyby v XML' : 'Zobrazit chyby v XML' }}</a>
        </div>
      </div>
    </fieldset>

  <fieldset  style="width: 700px;min-width: 400px;margin-left:auto;margin-right:auto;" class="mt-40" *ngIf="validationResponse && validationResponse.ku">
    <legend>Odkazy na stažení DGN ČUZK</legend>
    <div *ngFor="let ku of validationResponse.ku" class="mt-5"><a href="https://services.cuzk.cz/dgn/ku/{{ku.kod}}.zip" download>{{ku.nazev}} - {{ku.kod}}</a></div>
  </fieldset>

  <div *ngIf="xmlErrorsDisplayed && validationResponse && vfzeFileContent" class="mt-20">
    <vfze-problems [validationResponse]="validationResponse" [vfzeSource]="vfzeFileContent"></vfze-problems>
  </div>
</div>

<div class="flexbox-container mt-30 pl-20 pr-20" style="display: flex;
  flex-direction: row;       /* Řadí prvky vedle sebe (výchozí hodnota) */
  justify-content: center;   /* Vycentruje oba bloky horizontálně */
  align-items: flex-start;   /* Zarovná bloky k hornímu okraji (lze použít i 'center') */
  gap: 40px;">
  <fieldset class="no-padding" style="width:500px;background-color:transparent;">
    <legend>Soulad souboru vfze s validační šablonou</legend>
    <div><strong>Validátor VFZE disponuje aktuálně platnou validační šablonou VFZE. Kontroluje se:</strong></div>
    <ul class="mt-10">
      <li>správný datový typ pole</li>
      <li>max. a min. délka textových polí</li>
      <li>max. a min. rozsah číselných polí</li>
      <li>počet desetinných míst</li>
      <li>vyplnění povinných polí</li>
      <li>počet výskytů (0, 1, ..., n)</li>
      <li>vyplnění polí dle platného číselníku</li>
      <li>formát textových polí (PKN, PZE, IČO apod.)</li>
    </ul>
  </fieldset>

  <fieldset class="no-padding" style="width:500px;background-color:transparent;">
    <legend>Další datové a topologické kontroly souboru vfze</legend>
    <div><strong>Validátor VFZE dále kontroluje nezbytný datový soulad dat souboru a topologii geometrie. Kontroluje se:</strong></div>
    <ul class="mt-10">
      <li>existence parcel v ISKN (k 1. dni aktuálního měsíce)</li>
      <li>kontrola výměry parcely</li>
      <li>suma výměr záborů nemůže být větší než výměra parcely</li>
      <li>existence parcely v KN (RUIAN)</li>
      <li>přesahy ploch záborů vůči sobě</li>
      <li>souřadnicový systém</li>
      <li>kontrola veškerých ID (duplicity), a kontrola vazeb a odkazů na další elementy</li>
      <li>kód katastrálního území u parcely a budoucí parcely</li>
      <li>blok gpPEPV musí být uveden, pokud existuje blok gpParcela</li>
      <li>hodnoty Úsek/Etapa mezi daty u Záborů a Objektů</li>
      <li>duplicitní označení objektu</li>
      <li>výměra trvalého záboru a výměra zbytkové parcely pro ZE DSP, DUSP</li>
      <li>validace geometrie</li>
    </ul>
  </fieldset>
</div>
